<div class="row">
  <div class="col-lg-6">
    <div class="errors" *ngFor="let element of errorsToShow">
      <div>{{ element }}</div>
    </div>

    <!-- box de atendimento-->
    <spe-titulo-sessao titulo="Central de atendimento" icone="/assets/icones/cinza/atendimento.svg"></spe-titulo-sessao>

    <div class="background rounded-12 p-4" *ngIf="sigla != 'CAIXA'">
      <p>
        <b>Capitais e regiões metropolitanas: &nbsp;</b>3004 4242 <br />
        <b>Demais localidades: &nbsp;</b>0800 725 4242
      </p>
      <p class="mb-0">De segunda a sexta das 8:00 às 18:00</p>
    </div>

    <div class="background rounded-12 p-4" *ngIf="sigla == 'CAIXA'">
      <p>
        <b>Capitais e regiões metropolitanas: &nbsp;</b>3003 9590 <br />
        <b>Demais localidades: &nbsp;</b>0800 721 9590
      </p>
      <p class="mb-0">De segunda a sexta das 9:00 às 18:00</p>
    </div>

    <!-- formulario -->
    <spe-titulo-sessao titulo="Mensagem" icone="/assets/icones/cinza/contato.svg"></spe-titulo-sessao>

    <form [formGroup]="mainFormGroup">
      <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.tipoFormControl)">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="tipoFormControl">
          <mat-option value="Sugestões / Dúvidas">Sugestões / dúvidas</mat-option>
          <mat-option value="Reclamação">Reclamações</mat-option>
        </mat-select>
        <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
        <mat-error>{{ validatorErrors(mainFormGroup.controls.tipoFormControl) }}</mat-error>
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.assuntoFormControl)"
      >
        <mat-label>Assunto </mat-label>
        <mat-select name="listSubject" formControlName="assuntoFormControl">
          <mat-option *ngFor="let element of listSubject" [value]="element.value">
            {{ element.value }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
        <mat-error>{{ validatorErrors(mainFormGroup.controls.assuntoFormControl) }}</mat-error>
      </mat-form-field>

      <mat-form-field [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.nomeFormControl)">
        <mat-label>Nome </mat-label>
        <input matInput type="text" formControlName="nomeFormControl" />
        <mat-error>{{ validatorErrors(mainFormGroup.controls.nomeFormControl) }}</mat-error>
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.telefoneFormControl)"
        (keypress)="keypress($event)"
      >
        <mat-label>Telefone com DDD</mat-label>
        <input matInput mask="(00) 00000-0000" type="text" formControlName="telefoneFormControl" />
        <mat-error>
          {{ validatorErrors(mainFormGroup.controls.telefoneFormControl) }}
        </mat-error>
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.emailFormControl)"
      >
        <mat-label>E-mail </mat-label>
        <input matInput speLowercase type="email" required formControlName="emailFormControl" />
        <mat-error>{{ validatorErrors(mainFormGroup.controls.emailFormControl) }}</mat-error>
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(mainFormGroup.controls.mensagemFormControl)"
      >
        <mat-label>Mensagem</mat-label>
        <textarea rows="4" matInput formControlName="mensagemFormControl"></textarea>
        <mat-error>
          {{ validatorErrors(mainFormGroup.controls.mensagemFormControl) }}
        </mat-error>
      </mat-form-field>
    </form>

    <div class="text-end">
      <button
        mat-flat-button
        (click)="submitButton()"
        [ngClass]="{ caixaButton: sigla == 'CAIXA' }"
        [disabled]="!mainFormGroup.valid"
      >
        Enviar
      </button>
    </div>
  </div>
</div>
